import React from 'react';

export interface Sign4IconProps {}

export const Sign4Icon: React.FC<Sign4IconProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.3752 3.09562C19.452 3.14697 19.5149 3.21642 19.5585 3.29784C19.602 3.37926 19.6249 3.47016 19.625 3.5625V12C19.625 12.1123 19.5913 12.2221 19.5284 12.3151C19.4654 12.4082 19.376 12.4802 19.2717 12.522L19.0625 12L19.2717 12.522L19.2684 12.5231L19.2616 12.5265L19.2358 12.5366C19.0878 12.5954 18.9389 12.6517 18.7891 12.7054C18.4921 12.8123 18.0793 12.9563 17.6112 13.0991C16.6932 13.3826 15.4974 13.6875 14.5625 13.6875C13.6096 13.6875 12.821 13.3725 12.1347 13.0969L12.1033 13.0856C11.39 12.7987 10.7825 12.5625 10.0625 12.5625C9.275 12.5625 8.21975 12.8212 7.32088 13.0991C6.91841 13.2246 6.51962 13.3615 6.125 13.5098V20.4375C6.125 20.5867 6.06574 20.7298 5.96025 20.8352C5.85476 20.9407 5.71168 21 5.5625 21C5.41332 21 5.27024 20.9407 5.16475 20.8352C5.05926 20.7298 5 20.5867 5 20.4375V3.5625C5 3.41332 5.05926 3.27024 5.16475 3.16475C5.27024 3.05926 5.41332 3 5.5625 3C5.71168 3 5.85476 3.05926 5.96025 3.16475C6.06574 3.27024 6.125 3.41332 6.125 3.5625V3.87975C6.37925 3.79088 6.683 3.6885 7.01375 3.58725C7.93175 3.306 9.12875 3 10.0625 3C11.0075 3 11.777 3.31163 12.4486 3.58388L12.497 3.60413C13.1967 3.8865 13.8065 4.125 14.5625 4.125C15.35 4.125 16.4053 3.86625 17.3041 3.58837C17.8164 3.42841 18.3226 3.24979 18.8218 3.05287L18.8431 3.045L18.8476 3.04275H18.8488"
        fill="#192033"
      />
    </svg>
  );
};
